import React, { useEffect } from "react";
import "@/App.css";
import "@/lib/pdfFonts"; // Phase 66d — enregistrement police Sayonara pour les PDFs
import { BrowserRouter, Routes, Route, Navigate, Outlet, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { PWAUpdateBanner } from "@/components/InstallPWA";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import FieldOperatorDashboard from "@/pages/FieldOperatorDashboard";
import Products from "@/pages/Products";
import Translations from "@/pages/Translations";
import ProductionPlanning from "@/pages/ProductionPlanning";
import Stocks from "@/pages/Stocks";
import StockIntegrityAudit from "@/pages/StockIntegrityAudit";
import Reconciliation from "@/pages/Reconciliation";
import Parties from "@/pages/Parties";
import Orders from "@/pages/Orders";
import Labels from "@/pages/Labels";
import GuideOperateur from "@/pages/GuideOperateur";
import MenuCardsAdmin from "@/pages/MenuCardsAdmin";  // désactivé Phase 101ew (resto-checkout-58 remplace)
import CateringMenu from "@/pages/CateringMenu";
import Distributors from "@/pages/Distributors";
import DistributorActivity from "@/pages/DistributorActivity";
import DistributorSlots from "@/pages/DistributorSlots";
import DistributorComptoir from "@/pages/DistributorComptoir";
import ScannerHelp from "@/pages/ScannerHelp";
import Partners from "@/pages/Partners";
import PartnerCommission from "@/pages/PartnerCommission";
import Resellers from "@/pages/Resellers";
import ResellerApplications from "@/pages/ResellerApplications";  // legacy — gardé pour compat
import CandidaturesPro from "@/pages/CandidaturesPro";
import BecomeReseller from "@/pages/BecomeReseller";
import DistributorHostRequest from "@/pages/DistributorHostRequest";
import MenuTuiles from "@/pages/MenuTuiles";
import ResellerDetail from "@/pages/ResellerDetail";
import Contacts from "@/pages/Contacts";
import HaccpLotTrace from "@/pages/HaccpLotTrace";
import Settings from "@/pages/Settings";
import MorningBriefSettings from "@/pages/MorningBriefSettings";
import ShiftAlertSettings from "@/pages/ShiftAlertSettings";
import EmailProspection from "@/pages/EmailProspection";
import NayaxCsvImport from "@/pages/NayaxCsvImport";
import NayaxXlsxImport from "@/pages/NayaxXlsxImport";
import NayaxDiagnostic from "@/pages/NayaxDiagnostic";
import NayaxSyncLogs from "@/pages/NayaxSyncLogs";
import NayaxCockpit from "@/pages/NayaxCockpit";
import VisitPage from "@/pages/VisitPage";
import PackagingConsumables from "@/pages/PackagingConsumables";
import Packs from "@/pages/Packs";
import Inventories from "@/pages/Inventories";
import InventoryDetail from "@/pages/InventoryDetail";
import TechnicalSheet from "@/pages/TechnicalSheet";
import PrintHistory from "@/pages/PrintHistory";
import Traceability from "@/pages/Traceability";
import HaccpRegister from "@/pages/HaccpRegister";
import Sales from "@/pages/Sales";
import DeliveryNotes from "@/pages/DeliveryNotes";
import DeliveryNoteDetail from "@/pages/DeliveryNoteDetail";
import ClientOrders from "@/pages/ClientOrders";
import ClientOrderDetail from "@/pages/ClientOrderDetail";
import Invoices from "@/pages/Invoices";
import InvoiceDetail from "@/pages/InvoiceDetail";
import CateringQuotes from "@/pages/CateringQuotes";
import CateringQuoteDetail from "@/pages/CateringQuoteDetail";
import RefillTours from "@/pages/RefillTours";
import RefillTourDetail from "@/pages/RefillTourDetail";
import RefillTourPrepTablet from "@/pages/RefillTourPrepTablet";
import RefillTourExecute from "@/pages/RefillTourExecute";
import RefillTourReconcile from "@/pages/RefillTourReconcile";
import RefillTourOnSite from "@/pages/RefillTourOnSite";
import DlcLosses from "@/pages/DlcLosses";
import ReportsRetirees from "@/pages/ReportsRetirees";
import RetraitMobile from "@/pages/RetraitMobile";
import FieldTour from "@/pages/FieldTour";
import FieldTourList from "@/pages/FieldTourList";
import Statistics from "@/pages/Statistics";
import NayaxStats from "@/pages/NayaxStats";
import OrphanClientOrders from "@/pages/OrphanClientOrders";
import CompanyLetters from "@/pages/CompanyLetters";
import CompanyLetterDetail from "@/pages/CompanyLetterDetail";
import Login from "@/pages/Login";
import AdminForgotPassword from "@/pages/AdminForgotPassword";
import AdminResetPassword from "@/pages/AdminResetPassword";
import Users from "@/pages/Users";
import Suppliers from "@/pages/Suppliers";
import Ingredients from "@/pages/Ingredients";
import ShoppingList from "@/pages/ShoppingList";
import LabTests from "@/pages/LabTests";
import LegalPagesAdmin from "@/pages/LegalPagesAdmin";
import ProductCategories from "@/pages/ProductCategories";
import DeliverySettings from "@/pages/DeliverySettings";
import ShopCms from "@/pages/ShopCms";
import ShopPhotosCms from "@/pages/ShopPhotosCms";
import ShopCustomers from "@/pages/ShopCustomers";
import EmailSettings from "@/pages/EmailSettings";
import TelegramAlertSettings from "@/pages/TelegramAlertSettings";
import ScanAppro from "@/pages/ScanAppro";
import TemperatureHistory from "@/pages/TemperatureHistory";
import MenuCards from "@/pages/MenuCards";
import DistributorRestock from "@/pages/DistributorRestockRedirect";
import DistributorsOverview from "@/pages/DistributorsOverview";
import VitrineMachines from "@/pages/VitrineMachines";
import CreditNotes from "@/pages/CreditNotes";
import CreditNoteDetail from "@/pages/CreditNoteDetail";
import PublicTracePage from "@/pages/PublicTracePage";
import PublicCorporateMenu from "@/pages/PublicCorporateMenu";
import CorporateMagicLinkVerify from "@/pages/CorporateMagicLinkVerify";
import PublicPartnerMenu from "@/pages/PublicPartnerMenu";
import {
  CorporatePortalLogin,
  CorporatePortalActivate,
  CorporatePortalForgot,
  CorporatePortalReset,
  CorporatePortal,
} from "@/pages/CorporatePortal";
import { ShopLayout, ShopCatalog, ShopProductDetail } from "@/pages/Shop";
import { CartProvider, CartPage, CheckoutPage, ConfirmationPage, PaymentSuccessPage, PaymentFailurePage, TwintPendingPage } from "@/pages/ShopCart";
import { MentionsPage, CgvPage, PrivacyPage, StoryPage } from "@/pages/ShopLegal";
import {
  ShopRegisterPage, ShopLoginPage, ShopForgotPasswordPage,
  ShopResetPasswordPage, ShopVerifyEmailPage, ShopAccountPage,
} from "@/pages/ShopAuth";
import ResellerActivation from "@/pages/ResellerActivation";
import { ShopOrderDetailPage, ShopInvoiceDetailPage } from "@/pages/ShopCustomerPortal";
import { ShopAuthProvider } from "@/lib/shopAuth";
import { CorporateAuthProvider } from "@/lib/corporateAuth";
import { I18nProvider } from "@/lib/i18n";
import { AuthProvider, useAuth } from "@/lib/auth";
import { ConfirmProvider } from "@/components/ConfirmDialog";
import { PdfPreviewProvider } from "@/components/PdfPreview";
import RoleProtected from "@/components/RoleProtected";
import { loadSettings } from "@/lib/printer";
import { Loader2 } from "lucide-react";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F5F5F0]" data-testid="auth-loading">
        <Loader2 className="w-6 h-6 animate-spin text-[#1F4E3D]" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  // Phase 101gc — Verrou dur pour rôle `driver` : accès exclusif au module tournée.
  // Toute autre route est renvoyée vers /tournee (liste des machines).
  if (user.role === "driver") {
    const path = location.pathname;
    if (path !== "/tournee" && !path.startsWith("/tournee/") && path !== "/login") {
      return <Navigate to="/tournee" replace />;
    }
  }
  return children;
}

// Petit wrapper transparent : rend l'Outlet dans un provider parent.
// Utilisé pour envelopper les routes portail Corporate avec CorporateAuthProvider.
function OutletShell() {
  return <Outlet />;
}

/**
 * Routeur de la racine "/" : choisit la destination selon l'état d'auth.
 * - Visiteurs publics → /boutique (vitrine commerciale, pas d'écran de login intempestif).
 * - Utilisateurs connectés → /tableau-de-bord (Dashboard AgroManage admin).
 * Évite que `www.maison-thai.ch` redirige vers le login admin pour les clients de la boutique.
 */
function RootRedirect() {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F5F5F0]">
        <Loader2 className="w-6 h-6 animate-spin text-[#1F4E3D]" />
      </div>
    );
  }
  return <Navigate to={user ? (user.role === "driver" || user.role === "field_operator" ? "/tournee" : "/tableau-de-bord") : "/boutique"} replace />;
}

function AppContent() {
  const { user } = useAuth();

  useEffect(() => {
    if (user && user !== false) {
      loadSettings().catch(() => {});
    }
  }, [user]);

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      {/* Réinitialisation mot de passe admin — hors ShopLayout (Phase 101cy) */}
      <Route path="/mot-de-passe-oublie" element={<AdminForgotPassword />} />
      <Route path="/reset-admin/:token" element={<AdminResetPassword />} />
      {/* Pages publiques de traçabilité — scannées via QR code sur étiquettes barquettes */}
      <Route path="/trace/:sku" element={<PublicTracePage />} />
      <Route path="/trace/:sku/:lot_number" element={<PublicTracePage />} />
      {/* Vérification magic link Corporate — Phase 101et (avant /corporate/:id !) */}
      <Route path="/corporate/verify-magic-link" element={<CorporateMagicLinkVerify />} />
      {/* Portail Corporate — lien partagé par email à Novelis & assimilés (Phase 101cw) */}
      <Route path="/corporate/:id" element={<PublicCorporateMenu />} />
      {/* Catalogue Partenaire hébergeur — ex : Sion Piscine (Phase 101ep) */}
      <Route path="/partenaire/:id" element={<PublicPartnerMenu />} />
      {/* Portail Corporate authentifié (Phase 101cx-corp, Feb 2026) — Novelis */}
      <Route element={<CorporateAuthProvider><OutletShell /></CorporateAuthProvider>}>
        <Route path="/portail-corporate/login" element={<CorporatePortalLogin />} />
        <Route path="/portail-corporate/activer/:token" element={<CorporatePortalActivate />} />
        <Route path="/portail-corporate/mot-de-passe-oublie" element={<CorporatePortalForgot />} />
        <Route path="/portail-corporate/reinitialiser/:token" element={<CorporatePortalReset />} />
        <Route path="/portail-corporate" element={<CorporatePortal />} />
      </Route>
      {/* Racine : redirige vers /boutique (visiteurs) ou /tableau-de-bord (connectés) */}
      <Route path="/" element={<RootRedirect />} />
      {/* Landing publique B2B (Phase 59) */}
      <Route path="/devenir-revendeur" element={<BecomeReseller />} />

      {/* Landing publique « Devenir hôte distributeur » — Valais uniquement (Phase 100) */}
      <Route path="/hote-distributeur" element={<DistributorHostRequest />} />

      {/* Phase 98q — Menu Tuiles publique (accessible via QR code sur les machines) */}
      <Route path="/carte" element={<I18nProvider><MenuTuiles /></I18nProvider>} />
      <Route path="/carte/:distId" element={<I18nProvider><MenuTuiles /></I18nProvider>} />

      {/* Boutique publique (sans auth) — Phase 2a/2b */}
      <Route element={<I18nProvider><ShopAuthProvider><CartProvider><ShopLayout /></CartProvider></ShopAuthProvider></I18nProvider>}>
        <Route path="/boutique" element={<ShopCatalog />} />
        <Route path="/boutique/produit/:id" element={<ShopProductDetail />} />
        <Route path="/boutique/panier" element={<CartPage />} />
        <Route path="/boutique/checkout" element={<CheckoutPage />} />
        <Route path="/boutique/confirmation/:id" element={<ConfirmationPage />} />
        <Route path="/boutique/paiement/succes" element={<PaymentSuccessPage />} />
        <Route path="/boutique/paiement/echec" element={<PaymentFailurePage />} />
        <Route path="/boutique/paiement/twint-en-attente" element={<TwintPendingPage />} />
        <Route path="/boutique/histoire" element={<StoryPage />} />
        <Route path="/boutique/mentions" element={<MentionsPage />} />
        <Route path="/boutique/cgv" element={<CgvPage />} />
        <Route path="/boutique/confidentialite" element={<PrivacyPage />} />
        {/* Phase 29 — Comptes clients B2C */}
        <Route path="/boutique/inscription" element={<ShopRegisterPage />} />
        <Route path="/boutique/login" element={<ShopLoginPage />} />
        <Route path="/boutique/mot-de-passe-oublie" element={<ShopForgotPasswordPage />} />
        <Route path="/boutique/reinitialiser/:token" element={<ShopResetPasswordPage />} />
        <Route path="/boutique/verifier-email/:token" element={<ShopVerifyEmailPage />} />
        <Route path="/boutique/activer" element={<ResellerActivation />} />
        <Route path="/boutique/compte" element={<ShopAccountPage />} />
        <Route path="/boutique/compte/commandes/:id" element={<ShopOrderDetailPage />} />
        <Route path="/boutique/compte/factures/:id" element={<ShopInvoiceDetailPage />} />
      </Route>
      {/* Aperçu imprimable du Guide opérateur — hors Layout (pleine page A4) mais protégé par auth */}
      <Route path="/guide-imprimable" element={<ProtectedRoute><GuideOperateur preview /></ProtectedRoute>} />
      {/* Phase 101dc — Retrait rapide mobile (mini-AM) — PWA autonome, hors Layout (pas de sidebar) */}
      <Route path="/retrait-mobile" element={<ProtectedRoute><RetraitMobile /></ProtectedRoute>} />
      {/* Phase 101gc (Feb 2026) — Module Tournée terrain (AM Retrait amélioré).
          Hors Layout : accessible aux drivers (rôle verrouillé) + admin/operator/field_operator. */}
      <Route path="/tournee" element={<ProtectedRoute><FieldTourList /></ProtectedRoute>} />
      {/* Phase 101fk.6 — Rétro-compat : anciennes PWA installées avec start_url=/tournee/liste */}
      <Route path="/tournee/liste" element={<Navigate to="/tournee" replace />} />
      <Route path="/tournee/:id" element={<ProtectedRoute><FieldTour /></ProtectedRoute>} />
      {/* Phase 101fh — Vitrine machines : dashboard mural plein écran, style
          vitrine sombre. Hors Layout pour laisser tout l'espace visuel. */}
      <Route path="/vitrine-machines" element={<ProtectedRoute><VitrineMachines /></ProtectedRoute>} />
      <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route path="/tableau-de-bord" element={<Dashboard />} />
        {/* Phase 101gc — La route /tournee est désormais hors Layout (mode plein écran).
            L'ancien FieldOperatorDashboard reste accessible via /tableau-de-bord-tournee. */}
        <Route path="/tableau-de-bord-tournee" element={<FieldOperatorDashboard />} />
        <Route path="/produits" element={<RoleProtected><Products /></RoleProtected>} />
        {/* Route Cartes Restaurant retirée Phase 101ew (Feb 2026) — remplacée
            par le module externe resto-checkout-58 (caisse resto Emergent). */}
        <Route path="/carte-traiteur" element={<RoleProtected><CateringMenu /></RoleProtected>} />
        <Route path="/produits/traductions" element={<RoleProtected><Translations /></RoleProtected>} />
        <Route path="/produits/:id/fiche" element={<RoleProtected><TechnicalSheet /></RoleProtected>} />
        <Route path="/stocks" element={<Stocks />} />
        <Route path="/stocks/audit-integrite" element={<RoleProtected><StockIntegrityAudit /></RoleProtected>} />
        <Route path="/reconciliation" element={<RoleProtected><Reconciliation /></RoleProtected>} />
        <Route path="/parties" element={<RoleProtected><Parties /></RoleProtected>} />
        <Route path="/ordres" element={<RoleProtected><Orders /></RoleProtected>} />
        <Route path="/ordres/planning" element={<RoleProtected><ProductionPlanning /></RoleProtected>} />
        <Route path="/ventes" element={<Sales />} />
        <Route path="/bons-livraison" element={<RoleProtected><DeliveryNotes /></RoleProtected>} />
        <Route path="/bons-livraison/:id" element={<RoleProtected><DeliveryNoteDetail /></RoleProtected>} />
        <Route path="/commandes-clients" element={<RoleProtected><ClientOrders /></RoleProtected>} />
        <Route path="/commandes-clients/:id" element={<RoleProtected><ClientOrderDetail /></RoleProtected>} />
        <Route path="/factures" element={<RoleProtected><Invoices /></RoleProtected>} />
        <Route path="/factures/:id" element={<RoleProtected><InvoiceDetail /></RoleProtected>} />
        <Route path="/notes-de-credit" element={<RoleProtected><CreditNotes /></RoleProtected>} />
        <Route path="/notes-de-credit/:id" element={<RoleProtected><CreditNoteDetail /></RoleProtected>} />
        <Route path="/devis" element={<RoleProtected><CateringQuotes /></RoleProtected>} />
        <Route path="/devis/:id" element={<RoleProtected><CateringQuoteDetail /></RoleProtected>} />
        <Route path="/tournees-reappro" element={<RoleProtected><RefillTours /></RoleProtected>} />
        <Route path="/tournees-reappro/:id" element={<RoleProtected><RefillTourDetail /></RoleProtected>} />
        <Route path="/tournees-reappro/:id/prep-tablet" element={<RoleProtected><RefillTourPrepTablet /></RoleProtected>} />
        <Route path="/tournees-reappro/:id/execute" element={<RoleProtected><RefillTourExecute /></RoleProtected>} />
        <Route path="/tournees-reappro/:id/reconcilier" element={<RoleProtected><RefillTourReconcile /></RoleProtected>} />
        <Route path="/tournees-reappro/:id/terrain" element={<RoleProtected><RefillTourOnSite /></RoleProtected>} />
        {/* Phase 101fk (Feb 2026) — Module tablette visite unifiée (retrait DLC + comptage + chargement + PUT Nayax) */}
        <Route path="/visites/:id" element={<RoleProtected><VisitPage /></RoleProtected>} />
        <Route path="/pertes-dlc" element={<RoleProtected><DlcLosses /></RoleProtected>} />
        <Route path="/rapports/retirees" element={<RoleProtected><ReportsRetirees /></RoleProtected>} />
        <Route path="/statistiques" element={<RoleProtected><Statistics /></RoleProtected>} />
        <Route path="/statistiques/nayax" element={<RoleProtected><NayaxStats /></RoleProtected>} />
        <Route path="/commandes-orphelines" element={<RoleProtected><OrphanClientOrders /></RoleProtected>} />
        <Route path="/courriers" element={<RoleProtected><CompanyLetters /></RoleProtected>} />
        <Route path="/courriers/:id" element={<RoleProtected><CompanyLetterDetail /></RoleProtected>} />
        <Route path="/distributeurs" element={<RoleProtected><Distributors /></RoleProtected>} />
        <Route path="/distributeurs/:id" element={<RoleProtected><DistributorSlots /></RoleProtected>} />
        <Route path="/distributeurs/:id/comptoir" element={<RoleProtected><DistributorComptoir /></RoleProtected>} />
        <Route path="/aide/scanner" element={<RoleProtected><ScannerHelp /></RoleProtected>} />
        <Route path="/partenaires" element={<RoleProtected><Partners /></RoleProtected>} />
        <Route path="/partenaires/retribution" element={<RoleProtected><PartnerCommission /></RoleProtected>} />
        <Route path="/distributeurs/:id/activite" element={<RoleProtected><DistributorActivity /></RoleProtected>} />
        <Route path="/distributeurs/:id/reassort" element={<DistributorRestock />} />
        <Route path="/etat-distributeurs" element={<DistributorsOverview />} />
        <Route path="/revendeurs" element={<RoleProtected><Resellers /></RoleProtected>} />
        <Route path="/contacts" element={<RoleProtected><Contacts /></RoleProtected>} />
        <Route path="/haccp/lot-trace" element={<RoleProtected><HaccpLotTrace /></RoleProtected>} />
        <Route path="/packs" element={<RoleProtected><Packs /></RoleProtected>} />
        {/* Phase 101ew (Feb 2026) — Vue unifiée Revendeurs + Hôtes distributeur */}
        <Route path="/candidatures-pro" element={<RoleProtected><CandidaturesPro /></RoleProtected>} />
        {/* Redirect legacy vers la nouvelle page unifiée */}
        <Route path="/revendeurs/candidatures" element={<Navigate to="/candidatures-pro" replace />} />
        <Route path="/revendeurs/:id" element={<RoleProtected><ResellerDetail /></RoleProtected>} />
        <Route path="/inventaires" element={<RoleProtected><Inventories /></RoleProtected>} />
        <Route path="/inventaires/:id" element={<RoleProtected><InventoryDetail /></RoleProtected>} />
        <Route path="/etiquettes" element={<Labels />} />
        <Route path="/etiquettes/historique" element={<PrintHistory />} />
        <Route path="/guide" element={<GuideOperateur />} />
        <Route path="/tracabilite" element={<Traceability />} />
        <Route path="/haccp/registre" element={<RoleProtected><HaccpRegister /></RoleProtected>} />
        <Route path="/scan" element={<ScanAppro />} />
        <Route path="/scan/temperatures" element={<TemperatureHistory />} />
        <Route path="/cartes-imprimables" element={<RoleProtected><MenuCards /></RoleProtected>} />
        <Route path="/tests-labo" element={<RoleProtected><LabTests /></RoleProtected>} />
        <Route path="/parametres" element={<RoleProtected><Settings /></RoleProtected>} />
        <Route path="/parametres/utilisateurs" element={<RoleProtected><Users /></RoleProtected>} />
        <Route path="/parametres/fournisseurs" element={<RoleProtected><Suppliers /></RoleProtected>} />
        <Route path="/parametres/ingredients" element={<RoleProtected><Ingredients /></RoleProtected>} />
        <Route path="/parametres/liste-courses" element={<RoleProtected><ShoppingList /></RoleProtected>} />
        <Route path="/parametres/pages-legales" element={<RoleProtected><LegalPagesAdmin /></RoleProtected>} />
        <Route path="/parametres/categories" element={<RoleProtected><ProductCategories /></RoleProtected>} />
        <Route path="/parametres/livraison" element={<RoleProtected><DeliverySettings /></RoleProtected>} />
        <Route path="/parametres/cms-boutique" element={<RoleProtected><ShopCms /></RoleProtected>} />
        <Route path="/parametres/photos-boutique" element={<RoleProtected><ShopPhotosCms /></RoleProtected>} />
        <Route path="/parametres/clients-boutique" element={<RoleProtected><ShopCustomers /></RoleProtected>} />
        <Route path="/parametres/emails" element={<RoleProtected><EmailSettings /></RoleProtected>} />
        <Route path="/parametres/alerte-telegram" element={<RoleProtected><TelegramAlertSettings /></RoleProtected>} />
        <Route path="/parametres/brief-matinal" element={<RoleProtected><MorningBriefSettings /></RoleProtected>} />
        <Route path="/parametres/alertes-shift" element={<RoleProtected><ShiftAlertSettings /></RoleProtected>} />
        <Route path="/parametres/email-prospection" element={<RoleProtected><EmailProspection /></RoleProtected>} />
        <Route path="/parametres/import-nayax-csv" element={<RoleProtected><NayaxCsvImport /></RoleProtected>} />
        <Route path="/parametres/import-nayax-xlsx" element={<RoleProtected><NayaxXlsxImport /></RoleProtected>} />
        <Route path="/nayax/diagnostic" element={<RoleProtected><NayaxDiagnostic /></RoleProtected>} />
        <Route path="/nayax/cockpit" element={<RoleProtected><NayaxCockpit /></RoleProtected>} />
        <Route path="/parametres/nayax-sync-logs" element={<RoleProtected><NayaxSyncLogs /></RoleProtected>} />
        <Route path="/parametres/emballages" element={<RoleProtected><PackagingConsumables /></RoleProtected>} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <ConfirmProvider>
        <PdfPreviewProvider>
          <BrowserRouter>
            <AuthProvider>
              <AppContent />
            </AuthProvider>
          </BrowserRouter>
        </PdfPreviewProvider>
        <Toaster position="top-right" richColors />
        {/* Phase 101fk.4 (Feb 2026) — PWA install prompt + banner mise à jour */}
        <PWAUpdateBanner />
      </ConfirmProvider>
    </div>
  );
}

export default App;
